import { render, staticRenderFns } from "./dataShow.vue?vue&type=template&id=d454bff6&scoped=true"
import script from "./dataShow.vue?vue&type=script&lang=js"
export * from "./dataShow.vue?vue&type=script&lang=js"
import style0 from "./dataShow.vue?vue&type=style&index=0&id=d454bff6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d454bff6",
  null
  
)

export default component.exports